(function(){
'use strict';
/* Opt-in diagnostics only: keeps the normal storefront unchanged. */
try{if(new URLSearchParams(window.location.search).get('pmy_diagnostic')==='1')return;}catch(e){}
if(window.__PMY_HOME_GALLERY_2026__)return;
window.__PMY_HOME_GALLERY_2026__=true;

var COPY={
  en:{more:'See all photos',less:'Show fewer photos',loading:'Loading photos…',italy:'Italy'},
  pt:{more:'Ver mais fotos',less:'Ver menos fotos',loading:'Carregando fotos…',italy:'Itália'},
  es:{more:'Ver más fotos',less:'Ver menos fotos',loading:'Cargando fotos…',italy:'Italia'},
  fr:{more:'Voir plus de photos',less:'Voir moins de photos',loading:'Chargement des photos…',italy:'Italie'},
  de:{more:'Mehr Fotos anzeigen',less:'Weniger Fotos anzeigen',loading:'Fotos werden geladen…',italy:'Italien'},
  it:{more:'Vedi più foto',less:'Vedi meno foto',loading:'Caricamento foto…',italy:'Italia'},
  nl:{more:"Meer foto's bekijken",less:"Minder foto's bekijken",loading:"Foto's laden…",italy:'Italië'},
  ar:{more:'عرض المزيد من الصور',less:'عرض صور أقل',loading:'جارٍ تحميل الصور…',italy:'إيطاليا'},
  he:{more:'הצגת תמונות נוספות',less:'הצגת פחות תמונות',loading:'טוען תמונות…',italy:'איטליה'}
};

var PREVIEW_EXTRA_COUNT=5;
var MAX_EXTRA_COUNT=24;

/* PMY 2026-10-13: the Italy hero banner photos also feed the Italy gallery,
   so "Pictures of the Experiences" is not limited to the few product photos.
   Keep this list in sync with ITALY_HERO_IMAGES in pmy-service-country-bridge-core.js. */
var ITALY_GALLERY_IMAGES=[
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly1.jpg?v=1791825907',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly2.jpg?v=1791825907',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly3.jpg?v=1791825907',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly4.jpg?v=1791825904',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly5.jpg?v=1791825909',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly6.jpg?v=1791825895',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly7.jpg?v=1791825910',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly8.jpg?v=1791825904',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly9.jpg?v=1791825904',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly10.jpg?v=1791825904',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly11.jpg?v=1791825904',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly12.jpg?v=1791825907',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly13.jpg?v=1791825902',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly14.jpg?v=1791825910',
  'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/hbsiteitaly15.jpg?v=1791825901'
];

function langKey(){
  var l=(document.documentElement.lang||'en').toLowerCase();
  if(l.indexOf('pt')===0)return'pt';
  if(l.indexOf('es')===0)return'es';
  if(l.indexOf('fr')===0)return'fr';
  if(l.indexOf('de')===0)return'de';
  if(l.indexOf('it')===0)return'it';
  if(l.indexOf('nl')===0)return'nl';
  if(l.indexOf('ar')===0)return'ar';
  if(l.indexOf('he')===0)return'he';
  return'en'
}

function shopBase(){
  var b=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  return b.slice(-1)==='/'?b:b+'/'
}

function canonicalImage(src){
  if(!src)return'';
  try{
    var u=new URL(src,window.location.href);
    u.search='';
    u.hash='';
    return u.href
  }catch(e){
    return String(src).split('?')[0]
  }
}

function productJsonUrl(href){
  try{
    var u=new URL(href,window.location.href);
    if(u.origin!==window.location.origin||u.pathname.indexOf('/products/')===-1)return'';
    u.pathname=u.pathname.replace(/\/$/,'')+'.js';
    u.search='';
    u.hash='';
    return u.toString()
  }catch(e){
    return''
  }
}

function shopifyImageWidth(src,width){
  if(!src)return'';
  try{
    var u=new URL(src,window.location.href);
    if(!/shopify|cdn\.shopify\.com/i.test(u.hostname))return src;
    u.searchParams.set('width',String(width||900));
    return u.toString()
  }catch(e){
    return src
  }
}

function currentDestination(grid){
  if(!grid)return'portugal';
  return grid.querySelector('.pmy-home-gallery__item[data-destination="italy"]:not([hidden])')?'italy':'portugal'
}

function decoratePositions(grid){
  ['portugal','italy'].forEach(function(dest){
    var i=0;
    Array.prototype.forEach.call(
      grid.querySelectorAll('.pmy-home-gallery__item[data-destination="'+dest+'"]'),
      function(item){
        item.setAttribute('data-pmy-gallery-pos',String(i++))
      }
    )
  })
}

function markPreviewExtras(grid,dest){
  var extras=Array.prototype.slice.call(
    grid.querySelectorAll('.pmy-home-gallery__item[data-destination="'+dest+'"][data-pmy-gallery-extra="1"]')
  );
  extras.forEach(function(item,index){
    item.setAttribute('data-pmy-gallery-preview',index<PREVIEW_EXTRA_COUNT?'1':'0')
  });
  return Math.min(PREVIEW_EXTRA_COUNT,extras.length)
}

function init(root){
  var section=root.querySelector('.pmy-home-gallery-section');
  if(!section||section.__pmyGalleryEnhanced)return;

  var grid=section.querySelector('[data-pmy-home-gallery]');
  var head=section.querySelector('.pmy-home-section-head');
  if(!grid||!head)return;

  section.__pmyGalleryEnhanced=true;
  decoratePositions(grid);

  var labels=COPY[langKey()]||COPY.en;
  var state={
    portugal:{loaded:false,expanded:false,loading:false,extraCount:0,previewCount:0,manualLoad:false},
    italy:{loaded:false,expanded:false,loading:false,extraCount:0,previewCount:0,manualLoad:false}
  };

  var btn=document.createElement('button');
  btn.type='button';
  btn.className='pmy-home-gallery-more';
  btn.setAttribute('aria-expanded','false');
  btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"></rect><rect x="14" y="3" width="7" height="7" rx="1.5"></rect><rect x="14" y="14" width="7" height="7" rx="1.5"></rect><rect x="3" y="14" width="7" height="7" rx="1.5"></rect></svg><span></span>';
  head.appendChild(btn);

  var labelEl=btn.querySelector('span');

  function sync(){
    var dest=currentDestination(grid);
    var s=state[dest];
    var hasFoldedPhotos=s.loaded&&s.extraCount>s.previewCount;

    section.classList.toggle('is-expanded',!!s.expanded);
    btn.setAttribute('aria-expanded',s.expanded?'true':'false');
    btn.setAttribute('aria-busy',s.loading?'true':'false');
    btn.disabled=!!s.loading;
    btn.hidden=!!(s.loaded&&!hasFoldedPhotos);
    labelEl.textContent=(s.loading&&s.manualLoad)?labels.loading:(s.expanded?labels.less:labels.more)
  }

  function existingImages(dest){
    var set={};
    Array.prototype.forEach.call(
      grid.querySelectorAll('.pmy-home-gallery__item[data-destination="'+dest+'"] img'),
      function(img){
        var key=canonicalImage(img.currentSrc||img.src);
        if(key)set[key]=true
      }
    );
    return set
  }

  function productLinks(dest){
    var seen={};
    var links=[];

    Array.prototype.forEach.call(
      grid.querySelectorAll('.pmy-home-gallery__item[data-destination="'+dest+'"]'),
      function(item){
        if(item.getAttribute('data-pmy-gallery-extra')==='1')return;

        var href=item.href||item.getAttribute('href')||'';
        if(href&&!seen[href]&&productJsonUrl(href)){
          seen[href]=true;
          links.push(href)
        }
      }
    );

    return links.slice(0,7)
  }

  function appendExtra(dest,productHref,title,imgSrc,seen){
    var key=canonicalImage(imgSrc);
    if(!key||seen[key])return false;
    seen[key]=true;

    var a=document.createElement('a');
    a.className='pmy-home-gallery__item';
    a.href=productHref;
    a.setAttribute('data-destination',dest);
    a.setAttribute('data-pmy-gallery-extra','1');
    a.setAttribute('data-pmy-gallery-preview','0');
    a.setAttribute('aria-label',title||'Experience photo');
    a.hidden=dest!==currentDestination(grid);

    var img=document.createElement('img');
    img.src=shopifyImageWidth(imgSrc,760);
    img.srcset=shopifyImageWidth(imgSrc,420)+' 420w, '+shopifyImageWidth(imgSrc,760)+' 760w, '+shopifyImageWidth(imgSrc,1000)+' 1000w';
    img.sizes='(max-width: 700px) 50vw, 25vw';
    img.loading='lazy';
    img.decoding='async';
    img.alt=title||'Experience photo';

    var span=document.createElement('span');
    span.textContent=title||'';

    a.appendChild(img);
    a.appendChild(span);
    grid.appendChild(a);
    return true
  }

  function loadGallery(dest,expandAfterLoad,manualLoad){
    var s=state[dest];
    if(s.loaded){
      if(expandAfterLoad&&s.extraCount>s.previewCount)s.expanded=true;
      sync();
      return Promise.resolve(s.extraCount)
    }
    if(s.loading)return Promise.resolve(0);

    s.loading=true;
    s.manualLoad=!!manualLoad;
    sync();

    var seen=existingImages(dest);
    var links=productLinks(dest);
    var added=0;

    /* Italy: banner photos first, so the curated images lead the wall. */
    if(dest==='italy'){
      var italyHref=links[0]||(shopBase()+'collections/day-trips-italy');
      ITALY_GALLERY_IMAGES.forEach(function(src){
        if(added>=MAX_EXTRA_COUNT)return;
        if(appendExtra(dest,italyHref,labels.italy,src,seen))added++
      })
    }

    var jobs=links.map(function(href){
      var endpoint=productJsonUrl(href);
      if(!endpoint)return Promise.resolve(null);

      return fetch(endpoint,{
        credentials:'same-origin',
        headers:{Accept:'application/json'}
      })
      .then(function(res){
        if(!res.ok)throw new Error('Product gallery request failed');
        return res.json()
      })
      .catch(function(){
        return null
      })
    });

    return Promise.all(jobs).then(function(products){
      /* Round-robin keeps the wall varied instead of filling it with one tour first. */
      for(var imageIndex=0;imageIndex<8&&added<MAX_EXTRA_COUNT;imageIndex++){
        products.forEach(function(data,productIndex){
          if(!data||added>=MAX_EXTRA_COUNT)return;

          var images=Array.isArray(data.images)?data.images:[];
          var raw=images[imageIndex];
          var image=typeof raw==='string'?raw:(raw&&raw.src?raw.src:'');

          if(image&&appendExtra(dest,links[productIndex],data.title||'',image,seen)){
            added++
          }
        })
      }

      s.loaded=true;
      s.loading=false;
      s.manualLoad=false;
      s.extraCount=added;
      s.previewCount=markPreviewExtras(grid,dest);
      s.expanded=!!(expandAfterLoad&&added>s.previewCount);

      decoratePositions(grid);
      sync();
      return added
    }).catch(function(){
      s.loaded=true;
      s.loading=false;
      s.manualLoad=false;
      s.extraCount=added;
      s.previewCount=markPreviewExtras(grid,dest);
      s.expanded=false;
      sync();
      return added
    })
  }

  var autoLoadReady=false;

  function ensureCurrentPreview(force){
    if(!force&&!autoLoadReady)return;
    var dest=currentDestination(grid);
    var s=state[dest];
    sync();

    if(!s.loaded&&!s.loading){
      loadGallery(dest,false,false)
    }
  }

  btn.addEventListener('click',function(){
    var dest=currentDestination(grid);
    var s=state[dest];

    if(s.loading)return;

    if(!s.loaded){
      loadGallery(dest,true,true);
      return
    }

    if(s.extraCount<=s.previewCount)return;
    s.expanded=!s.expanded;
    sync()
  });

  root.addEventListener('click',function(e){
    if(e.target&&e.target.closest&&e.target.closest('[data-pmy-home-country],[data-pmy-country-main]')){
      setTimeout(ensureCurrentPreview,70)
    }
  });

  document.addEventListener('pmy:country-change',function(){
    setTimeout(ensureCurrentPreview,70)
  });

  sync();

  if('IntersectionObserver' in window){
    var observer=new IntersectionObserver(function(entries){
      if(!entries.some(function(entry){return entry.isIntersecting}))return;
      autoLoadReady=true;
      observer.disconnect();
      ensureCurrentPreview(true)
    },{rootMargin:'900px 0px'});
    observer.observe(section)
  }else{
    autoLoadReady=true;
    setTimeout(function(){ensureCurrentPreview(true)},900)
  }
}

function boot(){
  Array.prototype.forEach.call(document.querySelectorAll('[data-pmy-home-2026]'),init)
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',boot,{once:true})
}else{
  boot()
}
})();
